export function requiresSubscriptionRenewal(user) {
  if (!user) return false;

  return (
    user.subscriptionStatus === "EXPIRED" &&
    user.licenseTier === "CHURCH_ADMIN" &&
    user.platformRole !== "GLOBAL_ADMIN"
  );
}

export function requiresChurchOnboarding({
  user,
  isChurchAdminSubscription,
  churchesLoading,
  hasChurch,
  isOnboardingRoute,
  isProfileOnboardingRoute,
  isPlatformAdminRoute,
  isAuthRoute,
  skippedOnboarding,
}) {
  if (!isChurchAdminSubscription || churchesLoading) return false;
  if (user?.platformRole === "GLOBAL_ADMIN") return false;

  return !(
    hasChurch ||
    isOnboardingRoute ||
    isProfileOnboardingRoute ||
    isPlatformAdminRoute ||
    isAuthRoute ||
    skippedOnboarding
  );
}
